/* Sekcje 07 dzialaja niezaleznie takze po dodaniu w edytorze Shopify. */
(() => {
  const key = Symbol.for('naoko-k-07');
  if (window[key]) return;
  window[key] = true;
  const cleanups = new WeakMap();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    root.querySelectorAll('[data-nk="07-hero"], [data-nk="07-galeria"]').forEach(section => {
      if (cleanups.has(section)) return;
      const controller = new AbortController();
      const { signal } = controller;
      let timer;
      if (section.dataset.nk === '07-hero') {
        const slides = [...section.querySelectorAll('[data-slajd]')];
        let current = 0;
        let paused = motion.matches;
        let hovered = false;
        let focused = false;
        const pause = section.querySelector('[data-pause]');
        const show = index => {
          current = (index + slides.length) % slides.length;
          slides.forEach((slide, i) => { slide.hidden = i !== current; });
        };
        const schedule = () => {
          window.clearInterval(timer);
          if (!paused && !hovered && !focused && slides.length > 1) {
            timer = window.setInterval(() => show(current + 1), Math.max(2, Number(section.dataset.interwal) || 5) * 1000);
          }
          if (pause) {
            pause.setAttribute('aria-pressed', String(paused));
            pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
            pause.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
          }
        };
        section.querySelector('[data-prev]')?.addEventListener('click', () => { show(current - 1); schedule(); }, { signal });
        section.querySelector('[data-next]')?.addEventListener('click', () => { show(current + 1); schedule(); }, { signal });
        pause?.addEventListener('click', () => { paused = !paused; schedule(); }, { signal });
        motion.addEventListener('change', () => { paused = motion.matches; schedule(); }, { signal });
        section.addEventListener('focusin', () => { focused = true; schedule(); }, { signal });
        section.addEventListener('focusout', event => { focused = section.contains(event.relatedTarget); schedule(); }, { signal });
        section.addEventListener('mouseenter', () => { hovered = true; schedule(); }, { signal });
        section.addEventListener('mouseleave', () => { hovered = false; schedule(); }, { signal });
        schedule();
      } else {
        const frames = [...section.querySelectorAll('[data-duzy]')];
        const descriptions = [...section.querySelectorAll('[data-opis]')];
        const buttons = [...section.querySelectorAll('[data-miniatura]')];
        buttons.forEach((button, index) => button.addEventListener('click', () => {
          frames.forEach((frame, i) => { frame.hidden = i !== index; });
          descriptions.forEach((description, i) => { description.hidden = i !== index; });
          buttons.forEach((item, i) => item.setAttribute('aria-pressed', String(i === index)));
        }, { signal }));
      }
      cleanups.set(section, () => { window.clearInterval(timer); controller.abort(); cleanups.delete(section); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-nk="07-hero"], [data-nk="07-galeria"]').forEach(section => cleanups.get(section)?.());
  });
})();
